export default __webpack_public_path__ + "assets/images/pricing/a53a6d50cba1d480f73a51d897f4a144.png";